<template>
    <el-form :model="formValue" ref="formValue" :rules="rules" label-width="100px" class="" size="mini">
        <el-row>
            <el-col :span=8 :offset='7'>
                <el-form-item label="新密码" prop="newpasswd">
                    <el-input show-password v-model="formValue.newpasswd" placeholder='设置你的登录密码'></el-input>
                </el-form-item>
            </el-col>

        </el-row>
        <el-row>
            <el-col :span=8 :offset='7'>
                <el-form-item label="确认密码" prop="confirmpasswd">
                    <el-input show-password v-model="formValue.confirmpasswd" placeholder='再次确认新密码'></el-input>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row>
            <el-col :offset="9">
                <el-button type="primary" @click="submitForm" class="btn" :loading='passwordLoading'>保存更改</el-button>
            </el-col>
        </el-row>
    </el-form>
</template>

<script>

// let validatePass2 = (rule, value, callback) => {
//     console.log(value,this.formValue)
//     if (value !== this.formValue.confirmpasswd) {
//         callback(new Error('两次输入密码不一致!'));
//     } else {
//         callback();
//     }
// };

export default {
    name: 'changePassword',
    data () {
        let validatePass2 = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请再次输入密码'));
            } else if (value !== this.formValue.newpasswd) {
                callback(new Error('两次输入密码不一致!'));
            } else {
                callback();
            }
        };
        return {
            passwordLoading:false,
            formValue: {

            },

            rules: {
                newpasswd: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, message: '密码长度不少于6位', trigger: 'blur' }
                ],
                confirmpasswd: [
                    { required: true, message: '请输入确认密码', trigger: 'blur' },
                    { message: '两次密码不一致', validator: validatePass2, trigger: 'blur' }
                ],
            }
        }
    },
    methods: {
        submitForm () {

            this.$refs['formValue'].validate((valid) => {
                console.log(valid)
                if (valid) {
                    this.setPassword();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        setPassword(){
            this.passwordLoading = true;
            console.log(this.formValue)
            this.$store.dispatch('password',this.formValue).then((res)=>{
                this.passwordLoading = false;
                this.$message('修改成功');
                this.formValue = {};
            }).catch(()=>{
                this.passwordLoading = false;
            })
        }
    }
}
</script>

<style lang="stylus" scoped>
.btn
    width 290px
    background-image $btnBg
    border 0
    background-size 100% 100%
    margin-top 170px
    &:hover
        background-image $btnBg
        background-size 100% 100%
</style>


// WEBPACK FOOTER //
// src/components/my/myInfo/changePassword.vue